<template>
    <div id="job">
        <transition name="slide-fade" mode="out-in">
        <div class="mcontainer" v-if="this.$route.name === 'Job' ">
        <div class="flex justify-between relative mb-3">
            <div class="flex-1">
                <h2 class="text-lg font-semibold"> Job Opportunity </h2>
                <p>Temukan lowongan kerja dan bagikan kesempatan kerja.</p>
            </div>
        </div>
        <div class="flex row">
            <div class="col-md-4 order-md-2 mb-4 containerSticky">
            <vue-sticky-sidebar containerSelector=".containerSticky" innerWrapperSelector=".uk-sticky" :topSpacing='100'>
                <div uk-sticky="offset:100" class="uk-sticky card p-3">
                    <h4 class="text-lg font-semibold mb-3"> Categories </h4>
                    <ul class="list-checkbox" v-if="categories.length">
                        <li v-for="cat in categories" :key="cat.id">
                            <b-form-checkbox :value="cat.id" unchecked-value="" v-model="checkedCategory">
                                {{ cat.title }}
                            </b-form-checkbox>
                        </li>
                    </ul>
                    <p v-else class="text-gray-500 text-sm">Belum ada kategori</p>
                    <h4 class="text-lg font-semibold mb-3"> Tags </h4>
                    <div class="flex flex-wrap gap-2" v-if="tags.length">
                        <a href="#" class="bg-gray-100 py-1.5 px-4 rounded-full" :class="{ 'ring-2 ring-blue-500': selectedTag === tag }" @click.prevent="selectTag(tag)" v-for="tag in tags" :key="tag">{{ tag }}</a>
                    </div>
                    <p v-else class="text-gray-500 text-sm">Belum ada tags</p>
                </div>
            </vue-sticky-sidebar>
            </div>
            <div class="col-md-8 order-md-1">
                <div class="px-1">
                    <transition name="fade" mode="out-in">
                        <div class="job-list card" v-if="!loading">
                            <ListJob v-for="job in filteredJobs" :key="job.id" :data="job" @tag-click="selectTag" />
                        </div>
                        <div class="job-list p-4 card" v-else>
                            <content-placeholders v-for="index in 3" :key="index" class="my-3">
                            <content-placeholders-heading :img="true" />
                            <content-placeholders-text :lines="3" />
                            </content-placeholders>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        </div>
        <router-view/>
        </transition>
    </div>
</template>
<script>
import ListJob from '@/components/ListJob'
import vueStickySidebar from 'vue-sticky-sidebar'
import axios from 'axios'

export default {
  name: 'Job',
  components: { ListJob, vueStickySidebar },
  data () {
    return {
      jobs: [],
      categories: [],
      tags: [],
      checkedCategory: [],
      selectedTag: '',
      loading: true
    }
  },
  computed: {
    filteredJobs () {
      let list = this.jobs
      const catIds = Array.isArray(this.checkedCategory) ? this.checkedCategory : (this.checkedCategory ? [this.checkedCategory] : [])
      if (catIds.length) {
        const catIdsStr = catIds.map(id => String(id))
        list = list.filter(j => j.category_id != null && catIdsStr.includes(String(j.category_id)))
      }
      if (this.selectedTag) {
        list = list.filter(j => j.tags && j.tags.toLowerCase().includes(this.selectedTag.toLowerCase()))
      }
      return list
    }
  },
  async created () {
    await this.fetchCategoriesAndTags()
    await this.fetchJobs()
  },
  methods: {
    async fetchCategoriesAndTags () {
      try {
        const res = await axios.get('job/categories-tags')
        this.categories = res.data.categories || []
        this.tags = res.data.tags || []
      } catch (e) {
        console.error(e)
      }
    },
    async fetchJobs () {
      this.loading = true
      try {
        const res = await axios.get('job')
        this.jobs = res.data.result || []
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    selectTag (tag) {
      this.selectedTag = this.selectedTag === tag ? '' : tag
    }
  }
}
</script>
